// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3UvTRkMejmnkFkg6DBJE72"};